"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _OrderCard = _interopRequireDefault(require("../../Orders/OrderCard"));
var _Ticket = _interopRequireDefault(require("../Ticket"));
var _TourSelectionForm = _interopRequireDefault(require("../TourSelectionForm"));
var _ClientOrderListSkeleton = _interopRequireDefault(require("../../Clients/ClientOrderListSkeleton"));
var _ConversationList = _interopRequireDefault(require("../../Chains/ConversationList2"));
var _excluded = ["onDetachOrder", "onTicketClose", "onFieldChange", "onClickChain", "onCreateChain", "onDestinationInput", "onOrderSearch", "options", "orders", "ticket", "isOrdersLoading", "selectedChainId", "isFetchChainsLoading", "chains", "isCreateChain", "onClickOrderId", "onGoToLeadMailer", "onReserveTicket", "isTicketReservationLoading", "extraInfo"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OrderPropTypes = _OrderCard["default"].propTypes;
var TicketPropTypes = _Ticket["default"].propTypes,
  TYPES = _Ticket["default"].TYPES;
var FormPropTypes = _TourSelectionForm["default"].propTypes;
var TicketContainer = /*#__PURE__*/function (_React$PureComponent) {
  function TicketContainer(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketContainer);
    _this = _callSuper(this, TicketContainer, [props]);
    var tourForm = props.tourForm;
    var initialTourForm = _objectSpread({}, tourForm);
    _this.state = {
      initialTourForm: initialTourForm,
      formValues: initialTourForm
    };
    _this.handleFieldChange = _this.handleFieldChange.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleTicketCreate = _this.handleTicketCreate.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketContainer, _React$PureComponent);
  return (0, _createClass2["default"])(TicketContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var initialTourForm = this.state.initialTourForm;
      if (nextProps.tourForm !== initialTourForm) {
        this.setState(function () {
          return {
            formValues: nextProps.tourForm,
            initialTourForm: nextProps.tourForm
          };
        });
      }
    }
  }, {
    key: "handleFieldChange",
    value: function handleFieldChange(name, data) {
      if (name) {
        var onTicketFormChange = this.props.onTicketFormChange;
        var oldValues = this.state.formValues;
        var formValues = _objectSpread(_objectSpread({}, oldValues), {}, (0, _defineProperty2["default"])({}, name, data));
        this.setState({
          formValues: formValues
        }, function () {
          return onTicketFormChange((0, _defineProperty2["default"])({}, name, data));
        });
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props = this.props,
        ticket = _this$props.ticket,
        onTicketFormSave = _this$props.onTicketFormSave;
      var formValues = this.state.formValues;
      var validFormValues = (0, _pickBy2["default"])(formValues, function (v) {
        return v !== null;
      });
      onTicketFormSave(_objectSpread({
        ticketId: ticket.id
      }, validFormValues));
    }
  }, {
    key: "handleTicketCreate",
    value: function handleTicketCreate(props) {
      var _this$props2 = this.props,
        orders = _this$props2.orders,
        onTicketCreate = _this$props2.onTicketCreate;
      var orderIds = (orders || []).map(function (order) {
        return order.id;
      });
      onTicketCreate(_objectSpread(_objectSpread({}, props), {}, {
        orderIds: orderIds
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        onDetachOrder = _this$props3.onDetachOrder,
        onTicketClose = _this$props3.onTicketClose,
        onFieldChange = _this$props3.onFieldChange,
        onClickChain = _this$props3.onClickChain,
        onCreateChain = _this$props3.onCreateChain,
        onDestinationInput = _this$props3.onDestinationInput,
        onOrderSearch = _this$props3.onOrderSearch,
        options = _this$props3.options,
        ownOrders = _this$props3.orders,
        ticket = _this$props3.ticket,
        isOrdersLoading = _this$props3.isOrdersLoading,
        selectedChainId = _this$props3.selectedChainId,
        isFetchChainsLoading = _this$props3.isFetchChainsLoading,
        chains = _this$props3.chains,
        isCreateChain = _this$props3.isCreateChain,
        onClickOrderId = _this$props3.onClickOrderId,
        onGoToLeadMailer = _this$props3.onGoToLeadMailer,
        onReserveTicket = _this$props3.onReserveTicket,
        isTicketReservationLoading = _this$props3.isTicketReservationLoading,
        extraInfo = _this$props3.extraInfo,
        props = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      var _this$state = this.state,
        formValues = _this$state.formValues,
        initialTourForm = _this$state.initialTourForm;
      var savable = !(0, _isEqual2["default"])(initialTourForm, formValues);
      var type = (0, _get2["default"])(ticket, 'type');
      var reasons = options.reasons,
        countries = options.countries,
        closeReasons = options.closeReasons,
        planReasons = options.planReasons,
        departures = options.departures,
        destinations = options.destinations,
        hotelMeals = options.hotelMeals,
        irrelevanceReasons = options.irrelevanceReasons,
        sources = options.sources,
        partners = options.partners,
        segments = options.segments,
        mailGroups = options.mailGroups,
        managers = options.managers,
        tags = options.tags,
        types = options.types,
        orders = options.orders,
        menuSources = options.menuSources,
        suggestedOrders = options.suggestedOrders;
      return /*#__PURE__*/_react["default"].createElement(StyledTicketContainer, props, /*#__PURE__*/_react["default"].createElement(_Ticket["default"], {
        ticket: ticket,
        options: {
          reasons: reasons,
          closeReasons: closeReasons,
          mailGroups: mailGroups,
          managers: managers,
          tags: tags,
          types: types,
          orders: orders,
          menuSources: menuSources,
          planReasons: planReasons,
          suggestedOrders: suggestedOrders
        },
        onCreate: this.handleTicketCreate,
        onClose: onTicketClose,
        onFieldChange: onFieldChange,
        onOrderSearch: onOrderSearch,
        onReserveTicket: onReserveTicket,
        isTicketReservationLoading: isTicketReservationLoading,
        extraInfo: extraInfo
      }), type === TYPES.TOUR_SELECTION && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSplitter, null), /*#__PURE__*/_react["default"].createElement(_TourSelectionForm["default"], (0, _extends2["default"])({}, formValues, {
        options: {
          countries: countries,
          departures: departures,
          destinations: destinations,
          hotelMeals: hotelMeals,
          irrelevanceReasons: irrelevanceReasons,
          sources: sources,
          partners: partners,
          segments: segments
        },
        onGoToLeadMailer: onGoToLeadMailer,
        onChange: this.handleFieldChange,
        onDestinationInput: onDestinationInput
      })), savable && /*#__PURE__*/_react["default"].createElement(StyledSave, {
        onClick: this.handleSave
      }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0442\u0438\u043A\u0435\u0442")), isOrdersLoading ? /*#__PURE__*/_react["default"].createElement(StyledListSkeleton, null) : !(0, _isEmpty2["default"])(ownOrders) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSplitter, null), /*#__PURE__*/_react["default"].createElement(StyledSubTitle, null, (0, _size2["default"])(ownOrders) > 1 ? 'Тикет по заказам' : 'Тикет по заказу'), ownOrders.map(function (order) {
        return /*#__PURE__*/_react["default"].createElement(_OrderCard["default"], (0, _extends2["default"])({
          onClickOrderId: onClickOrderId,
          key: order.id,
          detachable: true,
          activeTicket: ticket,
          ticketable: false,
          onAttachTicket: onDetachOrder
        }, order));
      })), chains && (0, _get2["default"])(ticket, 'id') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSplitter, null), /*#__PURE__*/_react["default"].createElement(StyledConversationList, {
        onClickCard: onClickChain,
        onCreateConversation: onCreateChain,
        selectedId: selectedChainId,
        isFetchChainsLoading: isFetchChainsLoading,
        conversations: chains,
        isCreate: isCreateChain,
        total: (0, _get2["default"])(chains, 'length') || 0
      })));
    }
  }]);
}(_react["default"].PureComponent);
TicketContainer.propTypes = {
  className: _propTypes["default"].string,
  onFieldChange: _propTypes["default"].func,
  onNewTicket: _propTypes["default"].func,
  onDetachOrder: _propTypes["default"].func,
  onTicketClose: _propTypes["default"].func,
  onTicketCreate: _propTypes["default"].func,
  onTicketFormSave: _propTypes["default"].func,
  onTicketFormChange: _propTypes["default"].func,
  onClickChain: _propTypes["default"].func,
  onCreateChain: _propTypes["default"].func,
  onDestinationInput: _propTypes["default"].func,
  onOrderSearch: _propTypes["default"].func,
  options: _propTypes["default"].shape(_objectSpread(_objectSpread({}, TicketPropTypes.options), FormPropTypes.options)),
  orders: _propTypes["default"].arrayOf(_propTypes["default"].shape(OrderPropTypes).isRequired),
  ticket: TicketPropTypes,
  isOrdersLoading: _propTypes["default"].func,
  selectedChainId: _propTypes["default"].string,
  chains: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    unreadMessages: _propTypes["default"].number
  })),
  isCreateChain: _propTypes["default"].bool,
  tourForm: _propTypes["default"].shape({
    adults: FormPropTypes.adults,
    comment: FormPropTypes.comment,
    cityFromId: FormPropTypes.cityFrom,
    departureDates: FormPropTypes.departureDates,
    destination: FormPropTypes.destination,
    isNightsFlex: FormPropTypes.isNightsFlex,
    kids: FormPropTypes.kids,
    nights: FormPropTypes.nights,
    hotelMealId: FormPropTypes.pansion,
    partnerId: FormPropTypes.partnerId,
    price: FormPropTypes.price,
    segmentId: FormPropTypes.segmentId,
    sourceId: FormPropTypes.sourceId
  }),
  onClickOrderId: _propTypes["default"].func,
  onGoToLeadMailer: _propTypes["default"].func
};
TicketContainer.defaultProps = {
  className: '',
  onFieldChange: Function.prototype,
  onNewTicket: Function.prototype,
  onDetachOrder: Function.prototype,
  isOrdersLoading: false,
  onTicketClose: Function.prototype,
  onTicketCreate: Function.prototype,
  onTicketFormSave: Function.prototype,
  onTicketFormChange: Function.prototype,
  onClickChain: Function.prototype,
  onCreateChain: Function.prototype,
  onDestinationInput: Function.prototype,
  onOrderSearch: Function.prototype,
  onClickOrderId: Function.prototype,
  onGoToLeadMailer: Function.prototype,
  options: {
    reasons: [],
    countries: [],
    closeReasons: [],
    departures: [],
    destinations: [],
    irrelevanceReasons: [],
    mailGroups: null,
    managers: null,
    hotelMeals: [],
    partners: [],
    segments: [],
    sources: [],
    tags: [],
    orders: [],
    suggestedOrders: [],
    types: null
  },
  orders: null,
  ticket: null,
  selectedChainId: null,
  chains: null,
  isCreateChain: false,
  tourForm: null
};
var StyledTicketContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketContainer__StyledTicketContainer",
  componentId: "sc-7ms4hv-0"
})(["display:block;"]);
var StyledConversationList = (0, _styledComponents["default"])(_ConversationList["default"]).withConfig({
  displayName: "TicketContainer__StyledConversationList",
  componentId: "sc-7ms4hv-1"
})(["width:100%;"]);
var StyledSubTitle = _styledComponents["default"].span.withConfig({
  displayName: "TicketContainer__StyledSubTitle",
  componentId: "sc-7ms4hv-2"
})(["color:#919499;display:block;font-size:12px;margin-bottom:7px;"]);
var StyledListSkeleton = (0, _styledComponents["default"])(_ClientOrderListSkeleton["default"]).withConfig({
  displayName: "TicketContainer__StyledListSkeleton",
  componentId: "sc-7ms4hv-3"
})(["padding-top:10px;"]);
var StyledSave = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketContainer__StyledSave",
  componentId: "sc-7ms4hv-4"
})(["background:transparent;height:36px;margin-top:10px;"]);
var StyledSplitter = _styledComponents["default"].hr.withConfig({
  displayName: "TicketContainer__StyledSplitter",
  componentId: "sc-7ms4hv-5"
})(["background:#d9d9d9;border:none;height:1px;margin:15px 0;"]);
var _default = exports["default"] = TicketContainer;